<section class="d-flex flex-column align-items-center justify-content-center h-100">
    <mat-progress-spinner mode="indeterminate" style="transform: scale(0.5);"></mat-progress-spinner>
    <p *ngIf="message" class="mt-2 text-center">{{ message }}</p>
</section>
